import type { IntegerAmount } from '@actual-app/core/shared/util';

import { gastoPorCategoria } from '#components/mobile/informes/calculos';
import type {
  Categorias,
  Movimiento,
} from '#components/mobile/informes/calculos';

/**
 * «Gastado en octubre» de la cabecera de Movimientos (H59). Es el mismo
 * cálculo que el «Total gastado» del informe de Gastos y la tarjeta «Gasto
 * del mes» de Inicio (`gastoPorCategoria`), para que las tres cifras
 * coincidan: suma, por categoría de gasto, de lo que sale neto en el mes
 * (las devoluciones restan dentro de su categoría; una categoría con saldo
 * a favor no resta a las demás), sin categorías de ingreso. Los traspasos
 * entre cuentas propias y las cuentas fuera del presupuesto ya vienen
 * quitados de `movimientos` (`useTotalesMensuales`). Céntimos, en positivo.
 */
export function gastadoEnMes(
  movimientos: readonly Movimiento[],
  mes: string,
  categorias: Categorias,
): IntegerAmount {
  return gastoPorCategoria(movimientos, [mes], categorias).total;
}
